import { SET_ORDER_ITEMS } from './OrderActionTypes';
import type { OrderItemSummary } from '@model/Order.model';

export const setOrderItemsAction = (items: OrderItemSummary[]) => (dispatch: any) => {
  dispatch({
    type: SET_ORDER_ITEMS,
    payload: { items },
  });
};
